import Loadable from 'common/libs/Loadable/Loadable';
import DefaultLoadingScreen from 'common/components/DefaultLoadingScreen/DefaultLoadingScreen';

const SwitchProvider = Loadable({
  loader: () =>
    import(/* webpackChunkName: "SwitchProvider" */ '../containers/SwitchProvider'),
  loading: DefaultLoadingScreen,
});

export default SwitchProvider;
